/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { motion } from 'framer-motion';
import { Checkbox } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import {
  selectSelectedCycles,
  toggleSelectedCycles,
} from './store/cyclesSlice';

function ReviewSidebar() {
  const dev_cycles = [
    { title: 'SB ALPHA Development', color: '#FF55BF', id: 'dev_alpha_internal' },
    { title: 'SB ALPHA Review', color: '#80F2E7', id: 'dev_alpha' },
    { title: 'SB ALPHA Revision', color: '#FF55BF', id: 'dev_alpha_revision' },
    { title: 'SB BETA Review', color: '#48BF91', id: 'dev_beta' },
    { title: 'SB BETA Revision', color: '#FF55BF', id: 'dev_beta_revision' },
    { title: 'SB Final Review and Acceptance', color: '#013BB1', id: 'dev_final' },
  ];

  const prod_cycles = [
    { title: 'IMI ALPHA Development', color: '#8A2FFF', id: 'prod_alpha_internal' },
    { title: 'IMI ALPHA Review', color: '#80F2E7', id: 'prod_alpha' },
    { title: 'IMI ALPHA Revision', color: '#8A2FFF', id: 'prod_alpha_revision' },
    { title: 'IMI BETA Review', color: '#48BF91', id: 'prod_beta' },
    { title: 'IMI BETA Revision', color: '#8A2FFF', id: 'prod_beta_revision' },
    { title: 'IMI Final Review and Acceptance', color: '#013BB1', id: 'prod_final' },
  ];

  const trials_cycles = [
    { title: 'Pre-Trials QA', color: '#FF5454', id: 'trials_pre' },
    { title: 'Individual Trials Review', color: '#80F2E7', id: 'trials_individual' },
    { title: 'Individual Trials Revision', color: '#FF5454', id: 'trials_individual_revision' },
    { title: 'Group Trials Review', color: '#80F2E7', id: 'trials_group' },
    { title: 'Group Trials Revision', color: '#FF5454', id: 'trials_group_revision' },
    { title: 'Trials Final Review and Acceptance', color: '#013BB1', id: 'trials_final' },
  ];


  const selectedCycles = useSelector(selectSelectedCycles);
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col flex-auto min-h-full p-32">
      <motion.span
        initial={{ x: -20 }}
        animate={{ x: 0, transition: { delay: 0.2 } }}
        delay={300}
        className="pb-24 text-3xl font-extrabold tracking-tight"
      >
        Reviews
      </motion.span>

      <div className="mb-12">
        <Typography className="text-15 font-600 leading-none">
          Storyboard
        </Typography>
      </div>

      {dev_cycles.map((cycle) => (
        <div key={cycle.id} className="group flex items-center mt-8 space-x-8 w-full">
          <Checkbox
            color="default"
            className="p-0"
            checked={selectedCycles.includes(cycle.id)}
            onChange={() => {
              dispatch(toggleSelectedCycles(cycle.id));
            }}
          />

          <Box className="w-12 h-12 shrink-0 rounded-full" sx={{ backgroundColor: cycle.color }} />

          <Typography className="flex flex-1 leading-none">{cycle.title}</Typography>
        </div>
      ))}

      <Divider className="my-24" />

      <div className="mb-12">
        <Typography className="text-15 font-600 leading-none">
          Production
        </Typography>
      </div>

      {prod_cycles.map((cycle) => (
        <div key={cycle.id} className="group flex items-center mt-8 space-x-8 w-full">
          <Checkbox
            color="default"
            className="p-0"
            checked={selectedCycles.includes(cycle.id)}
            onChange={() => {
              dispatch(toggleSelectedCycles(cycle.id));
            }}
          />

          <Box className="w-12 h-12 shrink-0 rounded-full" sx={{ backgroundColor: cycle.color }} />

          <Typography className="flex flex-1 leading-none">{cycle.title}</Typography>
        </div>
      ))}

      <Divider className="my-24" />

      <div className="mb-12">
        <Typography className="text-15 font-600 leading-none">
          Trials
        </Typography>
      </div>

      {trials_cycles.map((cycle) => (
        <div key={cycle.id} className="group flex items-center mt-8 space-x-8 w-full">
          <Checkbox
            color="default"
            className="p-0"
            checked={selectedCycles.includes(cycle.id)}
            onChange={() => {
              dispatch(toggleSelectedCycles(cycle.id));
            }}
          />

          <Box className="w-12 h-12 shrink-0 rounded-full" sx={{ backgroundColor: cycle.color }} />

          <Typography className="flex flex-1 leading-none">{cycle.title}</Typography>
        </div>
      ))}
    </div>
  );
}

export default ReviewSidebar;